/** "Focus" — what to fix: the leak report (open patterns, each with a
 *  "Drill this leak" CTA) and the leaks you've already closed. */

import { ClosedLeaks } from "@/features/skills/components/ClosedLeaks";
import { LeakReportCard } from "@/features/skills/components/LeakReportCard";

export function FocusView() {
  return (
    <div className="space-y-6">
      <LeakReportCard />
      <ClosedLeaks />
    </div>
  );
}
